import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import empty_box from "../../images/empty_box.png";
import Client from "../../utils/client";

const MySales = () => {
  const [selectedSale, setSelectedSale] = useState(null);

  // Fetch sales
  const { data: sales, isFetching, isError, error } = useQuery({
    queryKey: ["sales"],
    queryFn: async () => {
      const response = await Client.get("/orders?type=seller").then((res) => res.data);
      return response;
    },
    initialData: [],
  });

  if (isError) {
    return (
      <div className="flex flex-col items-center mt-10 text-center">
        <motion.img
          src={empty_box}
          alt="Error"
          className="w-40 lg:w-48"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
        />
        <div className="font-bold mt-3 text-lg text-gray-700">
          حدث خطأ أثناء تحميل المبيعات
        </div>
        <div className="text-sm text-gray-500">{error.message}</div>
      </div>
    );
  }

  return (
    <div dir="rtl" className="w-full lg:px-20 relative">
      <h1 className="font-bold text-2xl lg:text-3xl my-10 text-primary">
        مبيعاتي
      </h1>
      {isFetching ? (
        <div dir="rtl" className="my-16 grid grid-cols-1 gap-4">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="p-4 bg-gray-100 border rounded-xl shadow-sm animate-pulse">
              <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div className="h-3 bg-gray-300 rounded w-1/2"></div>
            </div>
          ))}
        </div>
      ) : sales?.length === 0 ? (
        <div className="flex flex-col items-center mt-10 text-center">
          <motion.img
            src={empty_box}
            alt="No Sales"
            className="w-40 lg:w-48"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
          />
          <div className="font-bold mt-3 text-lg text-gray-700">
            لا توجد مبيعات
          </div>
        </div>
      ) : (
        <div className="flex flex-col gap-4">
          {sales.map((sale) => (
            <motion.div
              key={sale.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Link
                to={`/home/profile/order/${sale.id}`}
                onClick={() => setSelectedSale(sale.id)}
                className={`flex items-center p-4 bg-white border rounded-xl shadow-sm transition-all hover:shadow-md hover:scale-[1.02] ${selectedSale === sale.id ? "border-primary" : "border-gray-200"
                  }`}
              >
                {/* Image Section */}
                <img
                  src={sale.imageUrl || empty_box} // Use empty_box as fallback if imageUrl is missing
                  alt="Product"
                  className="w-16 h-16 object-cover rounded-lg ml-4"
                />

                {/* Sale Details */}
                <div className="flex flex-col text-right">
                  <div className="font-bold text-lg text-gray-800">
                    {sale.itemName || "Unnamed Product"}
                  </div>
                  <div className="text-sm text-gray-500">
                    السعر: {sale.price} | الكمية: {sale.quantity}
                  </div>
                  <div className="text-sm text-gray-400">
                    {new Date(sale.createdAt).toLocaleDateString("ar-EG", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MySales;